import type { ProfileGetPayload, UseGetProfileOptions } from "./profile.type";
import type { ApiError } from "@/services/api";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useAppLocale } from "@/services/language";

import { CURRENT_USER_PROFILE_QUERY_KEY } from "./profile.constant";

export const useGetProfile = (options?: UseGetProfileOptions) => {
  const { data, ...queryResult } = useQuery<ProfileGetPayload, ApiError>({
    queryKey: CURRENT_USER_PROFILE_QUERY_KEY,
    queryFn: () => client.profile.get(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    ...options,
  });

  return {
    profile: data?.data?.data,
    ...queryResult,
  };
};

export const useGetProfileLocale = () => {
  const { profile } = useGetProfile();
  const appLocale = useAppLocale();

  return profile?.locale ?? appLocale;
};
